module.exports = __webpack_public_path__ + "static/media/student-name.307506f6.png";